// extracted by mini-css-extract-plugin
module.exports = {"title":"Sign_title__2eCwl","signCanvas":"Sign_signCanvas__OPA01"};